import type { ComponentSize } from "./common.constants";

export type ButtonVariant =
  | "primary"
  | "secondary"
  | "outline"
  | "flat"
  | "success"
  | "warning"
  | "danger"
  | "info"
  | "link";

export const BUTTON_BASE_STYLE =
  "inline-flex items-center justify-center gap-2 cursor-pointer rounded-md font-medium transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 dark:focus:ring-offset-gray-900 disabled:opacity-50 disabled:cursor-not-allowed";

export const BUTTON_VARIANTS_STYLE: Record<ButtonVariant, string> = {
  primary:
    "bg-gradient-to-r from-primary-500 to-info-500 text-white transition hover:from-info-500 hover:to-primary-500 focus:ring-blue-400",
  secondary:
    "bg-gradient-to-r from-slate-700 to-gray-600 text-white hover:from-gray-600 hover:to-slate-700 focus:ring-gray-400",
  outline:
    "border border-gray-300 text-gray-800 hover:bg-gray-100 focus:ring-gray-400 dark:border-gray-600 dark:text-gray-100 dark:hover:bg-gray-800",
  flat: "text-gray-800 hover:bg-gray-100 focus:ring-gray-400 dark:text-gray-100 dark:hover:bg-gray-800",
  success:
    "bg-gradient-to-r from-emerald-500 to-green-600 text-white hover:from-green-600 hover:to-emerald-700 focus:ring-green-500",
  warning:
    "bg-gradient-to-r from-amber-400 to-yellow-500 text-black hover:from-yellow-500 hover:to-amber-600 focus:ring-yellow-400",
  danger:
    "bg-gradient-to-r from-rose-600 to-red-600 text-white hover:from-red-600 hover:to-rose-700 focus:ring-red-500",
  info: "bg-gradient-to-r from-sky-500 to-cyan-600 text-white hover:from-cyan-600 hover:to-sky-700 focus:ring-cyan-500",
  link: "bg-transparent px-0 text-blue-600 underline-offset-4 hover:underline focus:ring-blue-500 dark:text-blue-400",
};

export const BUTTON_SIZE_STYLE: Record<ComponentSize, string> = {
  xs: "px-2.5 py-1 text-xs",
  sm: "px-3 py-1.5 text-sm",
  md: "px-4 py-2 text-sm",
  lg: "px-5 py-2.5 text-base",
};
